import { Alert } from "../alert";

/**
 * Hinweissatz (M-002 F4, r105): Ablehnung oder Fehlschlag eines Vorgangs als ganzer Satz, an der Fläche des
 * Vorgangs (unter dem Feld oder im Dialog). Immer Alert Ton „warnung“, nie Toast, nie roher Fehlercode.
 * Ablehnung (übers Ziel, endgültig: „Diese Person steht nicht zur Verfügung.“) und Fehlschlag (über den Vorgang,
 * wiederholbar: „… Bitte erneut versuchen.“) unterscheiden sich nur im Wortlaut, den der Aufrufer liefert.
 * Am einzelnen Feld wird der Satz über `Feld` (`hinweissatz`) gesetzt; dieser Baustein ist für Stellen ohne
 * einzelnes Feld (Dialog, Abschnitt). Ein Feldfehler (F3) und ein Hinweissatz erscheinen nie zugleich (r100).
 */
export function Hinweissatz({ id, children }: { id?: string; children: React.ReactNode }) {
  return <Alert ton="warnung" id={id}>{children}</Alert>;
}
